import { LegalDocumentLayout } from '../components/LegalDocumentLayout';
import { COMPLAINTS_PROVIDER } from '../data/reclamaciones';
import { CONTACT } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

export function PrivacyPolicyPage() {
  useDocumentMeta({
    title: 'Política de privacidad | Corporación Indemniza',
    description: 'Información sobre el tratamiento de datos personales en los canales digitales de Corporación Indemniza.',
    canonicalPath: '/politica-de-privacidad',
    robots: 'noindex,nofollow',
  });

  return (
    <LegalDocumentLayout
      eyebrow="Privacidad y datos personales"
      title="Política de privacidad"
      intro="Información preliminar sobre cómo funcionan actualmente los formularios, WhatsApp y el Libro de Reclamaciones de Corporación Indemniza."
    >
      <section>
        <h2>1. Responsable identificado en el proyecto</h2>
        <dl className="legal-definition-list">
          <div><dt>Razón social</dt><dd>{COMPLAINTS_PROVIDER.razonSocial}</dd></div>
          <div><dt>Nombre comercial</dt><dd>{COMPLAINTS_PROVIDER.nombreComercial}</dd></div>
          <div><dt>RUC</dt><dd>{COMPLAINTS_PROVIDER.ruc}</dd></div>
          <div><dt>Domicilio</dt><dd>{COMPLAINTS_PROVIDER.direccion}</dd></div>
          <div><dt>Correo disponible en el sitio</dt><dd><a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></dd></div>
        </dl>
      </section>

      <section>
        <h2>2. Canales y datos que utiliza actualmente el sitio</h2>
        <h3>Contacto general y landing de negligencia médica</h3>
        <p>
          Los formularios de contacto solicitan nombre, una descripción del caso y, de manera opcional según el formulario,
          un teléfono. En la implementación técnica auditada esos datos no se envían a un backend propio del sitio:
          al validar el formulario se abre WhatsApp con un mensaje preparado y la persona decide si lo envía.
        </p>
        <p>
          Si utilizas WhatsApp, la información que efectivamente envíes también estará sujeta a las condiciones y políticas
          del servicio de WhatsApp. Evita incorporar información clínica o personal que no sea necesaria para el primer contacto.
        </p>

        <h3>Libro de Reclamaciones</h3>
        <p>
          El Libro de Reclamaciones sí remite información al servidor de Corporación Indemniza. El flujo actual contempla datos
          de identificación y contacto, domicilio, información de la relación de consumo, detalle del reclamo o queja, pedido,
          medio de respuesta y, cuando corresponda, datos del representante y archivos adjuntos.
        </p>
        <p>
          La implementación almacena el registro en una base de datos PostgreSQL, conserva los adjuntos en almacenamiento privado
          configurado para el Libro y genera notificaciones por correo electrónico. También registra un identificador derivado de
          la dirección IP mediante hash y el agente de usuario con fines técnicos de control y seguridad del formulario.
        </p>
      </section>

      <section>
        <h2>3. Finalidades técnicas identificadas</h2>
        <ul>
          <li>Facilitar que una persona contacte voluntariamente a Corporación Indemniza mediante teléfono o WhatsApp.</li>
          <li>Preparar el mensaje que la propia persona decide enviar mediante WhatsApp.</li>
          <li>Registrar, gestionar y responder reclamos o quejas presentados mediante el Libro de Reclamaciones.</li>
          <li>Enviar constancias y notificaciones relacionadas con el Libro de Reclamaciones.</li>
          <li>Aplicar controles técnicos de integridad, seguridad y prevención de envíos abusivos en el Libro de Reclamaciones.</li>
        </ul>
      </section>

      <section>
        <h2>4. Servicios externos visibles en la versión auditada</h2>
        <p>
          El sitio utiliza enlaces hacia WhatsApp y redes sociales, carga fuentes desde Google Fonts y muestra mapas mediante un
          iframe de Google Maps. La interacción con esos servicios puede implicar tratamiento de información técnica conforme a
          las políticas de sus respectivos proveedores.
        </p>
        <p>
          En la versión de código auditada para esta política no se han instalado todavía Google Tag Manager, Google Analytics,
          Meta Pixel ni conversiones de Google Ads. Si posteriormente se incorporan herramientas de medición o publicidad,
          esta política y los mecanismos de información o consentimiento aplicables deberán revisarse antes de su activación.
        </p>
      </section>

      <section>
        <h2>5. Derechos sobre los datos personales</h2>
        <p>
          La legislación peruana reconoce, entre otros, los derechos de acceso, rectificación, cancelación y oposición respecto
          del tratamiento de datos personales. La versión legal definitiva debe confirmar el canal formal que utilizará
          Corporación Indemniza para recibir y atender estas solicitudes.
        </p>
      </section>

      <section className="legal-pending-section">
        <h2>6. Información pendiente de validación legal antes de publicación definitiva</h2>
        <p>El proyecto técnico no permite afirmar de manera responsable los siguientes puntos, por lo que deben ser confirmados:</p>
        <ul>
          <li>Identificación y situación registral de los bancos de datos personales que correspondan.</li>
          <li>Plazos exactos de conservación y criterios de eliminación de cada categoría de datos y adjuntos.</li>
          <li>Relación completa de encargados, destinatarios y eventuales transferencias nacionales o internacionales.</li>
          <li>Canal, procedimiento y plazos internos definidos por Corporación Indemniza para el ejercicio de derechos.</li>
          <li>Base jurídica y textos de consentimiento que correspondan a cada tratamiento, especialmente antes de activar analítica o publicidad.</li>
        </ul>
      </section>

      <section>
        <h2>7. Referencia normativa</h2>
        <p>
          La versión definitiva deberá revisarse conforme a la Ley N.º 29733, Ley de Protección de Datos Personales, y su
          Reglamento aprobado por Decreto Supremo N.º 016-2024-JUS, vigente desde el 31 de marzo de 2025.
        </p>
      </section>
    </LegalDocumentLayout>
  );
}
